import { DateTime } from 'luxon';
import React from 'react';
import { useParams } from 'react-router-dom';

import { useRecuperarAvaliacoesDesempenhoQuery } from 'View/Service/Default/AvaliacoesDesempenho';

const AvaliacoesDesempenho = (): React.ReactElement => {
  const { id = 0 } = useParams();

  const { data: { avaliacoes } = {} } = useRecuperarAvaliacoesDesempenhoQuery({
    options: { usuario_id: id },
  });

  const selecionar = (id: number): void => {
    window.open(`/avaliacoes-desempenho/${id}`);
  };

  return (
    <React.Fragment>
      <div className="bg-white shadow-sm rounded">
        {avaliacoes?.map((avaliacao) => (
          <div
            key={`${avaliacao.id}-${avaliacao.modificado}`}
            className="d-flex border-bottom align-items-center justify-content-between py-2 px-3"
            onClick={() => selecionar(avaliacao.id)}
          >
            <div className="fs-4">
              {avaliacao.criado.data().toLocaleString(DateTime.DATETIME_SHORT)}
            </div>
          </div>
        ))}
      </div>
    </React.Fragment>
  );
};

export default AvaliacoesDesempenho;
